import script from "./MobileMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileMenu.vue?vue&type=script&setup=true&lang=js"

import "./MobileMenu.vue?vue&type=style&index=0&id=5fd89705&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd89705"]])

export default __exports__